module.exports = __webpack_public_path__ + "static/img/sc8.23d1e86.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc8.png
// module id = X8JT
// module chunks = 25